<template>
  <div class="w-full h-full p-4">
    <div class="w-full h-full relative">
      <div class="w-full h-full absolute bg-white rounded-content-lg"></div>
      <div
        class="relative w-full h-full flex flex-col justify-between items-center p-8"
      >
        <div class="flex justify-between items-center w-full">
          <div class="flex gap-2 items-center">
            <div class="w-12 h-12">
              <img src="/images/logo.png" class="w-full h-full" alt="" />
            </div>
            <div>EkiDiscount</div>
          </div>
          <div class="text-sm text-right">
            <span class="text-[#959496]"> Déjà un compte ? </span>
            <br class="md:hidden" />
            <router-link to="/login" class="font-bold text-primary">
              Connectez-vous
            </router-link>
          </div>
        </div>

        <div class="md:w-[35rem]">
          <div class="text-4xl font-bold title-color text-center">
            Inscrivez-vous
          </div>
          <!-- <div class="py-1"></div>
          <div>Veuillez entrer vos invormation pour accéder à votre compte</div> -->
          <div class="py-3"></div>
          <div class="flex justify-around">
            <button
              class="border-[0.2rem] flex items-center gap-2 rounded-2xl py-3 px-4 title-color"
              @click="loginWithGoogle"
            >
              <div class="w-6 h-6">
                <img src="@/assets/images/icons/google-g.png" alt="" />
              </div>
              <div>Inscription avec Google</div>
            </button>
          </div>
          <div class="py-4"></div>
          <div class="flex items-center justify-center">
            <div class="w-full border-b-[0.2rem]"></div>
            <div
              class="absolute w-8 h-8 bg-white flex items-center justify-center"
            >
              <div>Ou</div>
            </div>
          </div>
          <div class="py-3"></div>
          <div>
            <FormComponent
              class="w-full grid grid-cols-12 gap-x-4"
              :fields="fields"
              :onFormSubmited="
                data => {
                  requestRegistration(data)
                }
              "
              :loading="false"
              ref="form"
            >
              <template #submitButton>
                <button class="hidden" type="submit" ref="submit"></button>
              </template>
            </FormComponent>
          </div>
          <div class="py-1"></div>
          <div class="w-full">
            <button @click="$refs.submit.click" class="buttonComponent w-full">
              M'inscrire
            </button>
          </div>
        </div>
        <div class="text-center text-[#959496]">
          &copy; 2025. Tous droits réservés.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormComponent from '../utils/FormComponent.vue'

export default {
  components: { FormComponent },
  data() {
    return {
      fields: [
        {
          type: 'text',
          propertyName: 'lastName',
          label: this.$t('register.lastNameInputLabel'),
          defaultValue: '',
          placeHolder: 'Entrez votre prénom',
          inputProps: {
            minLenght: 3,
          },
          required: true,
          class: 'col-span-6',
        },
        {
          type: 'text',
          propertyName: 'firstName',
          placeHolder: 'Entrez votre nom',
          label: this.$t('register.firstNameInputLabel'),
          inputProps: {
            minLenght: 3,
          },
          defaultValue: '',
          required: true,
          class: 'col-span-6',
        },
        // {
        //   type: 'select',
        //   propertyName: 'countryPrefix',
        //   options: this.$Countries.getSignupCountries().sort((ca, cb) => {
        //     if (ca.countryName > cb.countryName) return 1
        //     if (ca.countryName < cb.countryName) return -1
        //     return 0
        //   }),
        //   formatOptionInputDisplay(country) {
        //     return `+${country.callingCode}`
        //   },
        //   formatOptionsDisplay(country) {
        //     return `+${country.callingCode}`
        //   },
        //   // formatOptionsDisplay(country) {
        //   //   return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
        //   //     country.countryName
        //   //   }</span><span class="absolute left-[calc(100vw-110px)] w-[50px] text-right">+${
        //   //     country.callingCode
        //   //   }</span></div>`
        //   // },
        //   inputProps: {
        //     selectTitle: 'Séléctionnez un préfix',
        //     useModal: false,
        //     hideSelectedCheck: true,
        //   },
        //   label: '',
        //   defaultValue: `+229`,
        //   required: true,
        //   class:
        //     ' !w-[6rem] relative z-[2] pl-3 locationCountry phonePrefix  [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-l [&_.inputContainer]:!absolute [&_.inputContainer]:!pl-3 [&_input]:!p-[0px] countryPrefix',
        // },
        // {
        //   type: 'number',
        //   propertyName: 'phoneNumber',
        //   label: this.$t('register.phoneNumberInputLabel'),
        //   defaultValue: '',
        //   placeHolder: 'Entrez votre nom',

        //   required: true,
        //   class:
        //     'col-span-12 [&_input]:!pl-[7rem] [&_label]:!pl-[6rem] [&_input:focus_~_label]:!pl-[0px]  [&_input:not(.empty)_~_label]:!pl-[0px]',
        // },
        {
          placeHolder: 'Entrez votre Email',

          type: 'email',
          propertyName: 'email',
          label: this.$t('register.emailInputLabel'),
          defaultValue: '',
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'password',
          propertyName: 'password',
          label: this.$t('register.passwordInputLabel'),
          placeHolder: '********',
          defaultValue: '',
          inputProps: {
            minLenght: 6,
          },
          required: true,
          class: 'col-span-12',
        },
        {
          type: 'toggle',
          propertyName: 'termOfUse',
          label: this.$t('register.acceptTerms', {
            termLinkAttr: `href="https://1bpay.me/terms" target="_blank" class="underline text-primary"`,
          }),
          defaultValue: true,
          required: true,
          class:
            ' -my-7 col-span-12 [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-lg [&_input]:!p-[0px]',
        },
      ],
      eventsIds: [],
      userCountry: {},
      loading: false,
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    const id = this.$Events.handleEvent(
      'registration_done',
      this.onRegistrationDone,
    )
    const id2 = this.$Events.handleEvent(
      'registration_failed',
      this.onRegistrationFailed,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    requestRegistration(inputData) {
      if (this.loading) return
      this.loading = true
      const phoneNumber = `${this.userCountry.phonePrefix}${
        inputData.phoneNumber
      }`
      const data = JSON.parse(JSON.stringify(inputData))
      data.phoneNumber = phoneNumber
      delete data.selectedCountry
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('registration_requested', data)
    },
    onRegistrationDone() {
      this.$router.push('/home')
      this.$Events.dispatchEvent('finish_loading')
      this.loading = false
    },
    onRegistrationFailed(data) {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        title: this.$t('register.registrationError'),
        body:
          this.$t(data.messageId) ||
          this.$t('register.registrationErrorFallback'),
      })
      this.loading = false
    },
    loginWithGoogle() {
      this.$Events.dispatchEvent('login_with_google_required')
    },
  },
}
</script>
